import { Component } from '@angular/core';

@Component({
  selector: 'about-spray-records',
  templateUrl: 'about-spray-records.html'
})
export class AboutSprayRecordsPage {
  constructor() {}
}




// WEBPACK FOOTER //
// ./src/pages/about-spray-records/about-spray-records.ts